import * as types from '@/store/mutation-types'
import api from '@/services/api/adminAccess'
import { handleError, buildSuccess } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = {
  vips: state => state.vips,
  totalVips: state => state.totalVips,
  blockeds: state => state.blockeds,
  totalBlockeds: state => state.totalBlockeds
}

const actions = {
  getVipDevices({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      // commit(types.SHOW_TOP_LOADING, true)
      api
        .getVips(payload)
        .then(response => {
          //console.log(JSON.stringify(response,null,2))
          if (response.status === 200) {

            commit(types.VIPS, response.data.docs)
            commit(types.TOTAL_VIPS, response.data.totalDocs)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
            //commit(types.SHOW_LOADING, false)
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  getBlockedDevices({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      // commit(types.SHOW_TOP_LOADING, true)
      api
        .getBlockeds(payload)
        .then(response => {
          //console.log(JSON.stringify(response,null,2))
          if (response.status === 200) {

            commit(types.BLOCKEDS, response.data.docs)
            commit(types.TOTAL_BLOCKEDS, response.data.totalDocs)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
            //commit(types.SHOW_LOADING, false)
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  makeDeviceVip({ commit }, payload){
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      commit(types.SHOW_LOADING, true)
      api
        .vipDevice(payload)
        .then(response => {
          if (response.status === 200) {
            console.log(JSON.stringify(response,null,2))
            commit(types.SHOW_LOADING, false)
            buildSuccess(
              {
                msg: 'common.SAVED_SUCCESSFULLY'
              },
              commit,
              resolve
            )
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  blockUserAccess({ commit }, payload){
    console.log(JSON.stringify(payload,null,2))
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      commit(types.SHOW_LOADING, true)
      api
        .blockUser(payload)
        .then(response => {
          if (response.status === 200) {
            commit(types.SHOW_LOADING, false)
            buildSuccess(
              {
                msg: 'common.SAVED_SUCCESSFULLY'
              },
              commit,
              resolve
            )
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  }
}

const mutations = {
  [types.VIPS](state, value) {
    state.vips = value
  },
  [types.TOTAL_VIPS](state, value) {
    state.totalVips = value
  },
  [types.BLOCKEDS](state, value) {
    state.blockeds = value
  },
  [types.TOTAL_BLOCKEDS](state, value) {
    state.totalBlockeds = value
  }

}

const state = {
  vips: [],
  totalVips: 0,
  blockeds: [],
  totalBlockeds: 0
}

export default {
  state,
  getters,
  actions,
  mutations
}
